import Analytics from '../../../../../../../analytics';

export const faOnLeftArrowClick = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.NAVIGATION_ICON_CLICKED,
    event_value: 'Collection_click_left',
  });
};
export const faOnRightArrowClick = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.NAVIGATION_ICON_CLICKED,
    event_value: 'Collection_click_right',
  });
};

export const faOnCollectionsTabSelect = value => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: value,
  });
};
